import React, { type FC } from "react";

import logo from "../../assets/binale_logo.svg";

export const LogoHeader: FC = () => (
    <div className="flex justify-center items-center my-4">
        <img src={logo} alt="logotype" className="w-[30px]" />
        <h3 className="text-xl font-semibold mb-0 ml-2.5">Binale</h3>
    </div>
);
